import React from 'react';
import cx from 'classnames';
import { CARD_OVERLAY_MORE_ICON } from '../../styles/card';
import ActionPopup from '../../../../../ActionPopup';





const Actions = ({ options }) =>
<div className={cx(
  'card_overlay__popup-container',
  CARD_OVERLAY_MORE_ICON
)}>

    <ActionPopup
    options={options} />

  </div>;


export default Actions;